import React from 'react';
import { Link } from 'react-router-dom';
import { showNewSubLink } from 'helpers/users';

const NewUserSubLink = ({ user }) => (
  <span>
    {showNewSubLink(user) && (
      <Link to={`/users/${user.id}/quick/new-subscription`}>
        <button className="btn btn-default">Add Quick Subscription</button>
      </Link>
    )}
  </span>
);

export default NewUserSubLink;
